// extracted by mini-css-extract-plugin
module.exports = {"link":"button-link_link__q_O7x"};